import { E_ROUTE_SEARCHENGINE_MANAGEMENT, E_ROUTE_SYSTEM } from './route.types';
import { currentEnvironment } from '@/config/envConfig';
const ENABLE_REGION_SWITCH = ['qa', 'stage'].includes((currentEnvironment || '').toLowerCase());
const systemBreadcrumb = [
    {
        text: 'backoffice.nav.DeveloperTool',
    },
    {
        text: 'backoffice.nav.System',
    },
    {
        text: 'backoffice.nav.SearchEngineManagement',
        active: true,
    }
];
export default [
    {
        name: E_ROUTE_SYSTEM.SEARCH_ENGINE_MANAGEMENT,
        path: '/system/search-engine-management',
        component: () => import(/* webpackChunkName: "system" */ '../../views/system/SearchEngineManagement/SearchEngineManagement.vue'),
        redirect: '/system/search-engine-management/company',
        children: [
            {
                name: E_ROUTE_SEARCHENGINE_MANAGEMENT.COMPANY,
                path: 'company',
                component: () => import(/* webpackChunkName: "system" */ '../../views/system/SearchEngineManagement/SearchEngineManagementCompany/SearchEngineManagementCompany.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        ...systemBreadcrumb,
                        {
                            text: 'backoffice.SearchEngineManagement.company',
                            active: true,
                        }
                    ],
                    permission: 'CompanyIndexGetList',
                },
            },
            {
                name: E_ROUTE_SEARCHENGINE_MANAGEMENT.ACCOUNT,
                path: 'account',
                component: () => import(/* webpackChunkName: "system" */ '../../views/system/SearchEngineManagement/SearchEngineManagementUser/SearchEngineManagementUser.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        ...systemBreadcrumb,
                        {
                            text: 'backoffice.SearchEngineManagement.account',
                            active: true,
                        }
                    ],
                    permission: 'AccountIndexGetList',
                },
            },
            {
                name: E_ROUTE_SEARCHENGINE_MANAGEMENT.PACKAGE,
                path: 'package',
                component: () => import(/* webpackChunkName: "system" */ '../../views/system/SearchEngineManagement/SearchEngineManagement/SearchEngineManagement.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        ...systemBreadcrumb,
                        {
                            text: 'backoffice.SearchEngineManagement.package',
                            active: true,
                        }
                    ],
                    permission: 'AccountIndexGetList',
                },
            },
            {
                name: E_ROUTE_SEARCHENGINE_MANAGEMENT.GROUP,
                path: 'group',
                component: () => import(/* webpackChunkName: "system" */ '../../views/system/SearchEngineManagement/SearchEngineManagement/SearchEngineManagement.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        ...systemBreadcrumb,
                        {
                            text: 'backoffice.SearchEngineManagement.package',
                            active: true,
                        }
                    ],
                    permission: 'AccountIndexGetList',
                },
            },
            {
                name: E_ROUTE_SEARCHENGINE_MANAGEMENT.GROUP_MEMBER,
                path: 'group-member',
                component: () => import(/* webpackChunkName: "system" */ '../../views/system/SearchEngineManagement/SearchEngineManagement/SearchEngineManagement.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        ...systemBreadcrumb,
                        {
                            text: 'backoffice.SearchEngineManagement.package',
                            active: true,
                        }
                    ],
                    permission: 'AccountIndexGetList',
                },
            }
        ],
    },
    {
        name: E_ROUTE_SYSTEM.SYSTEM_SAML,
        path: '/system/system-saml',
        component: () => import(/* webpackChunkName: "system" */ '../../views/system/SystemSaml/SystemSaml.vue'),
        props: true,
        meta: {
            keepAlive: false,
            breadcrumb: [
                {
                    text: 'backoffice.nav.DeveloperTool',
                },
                {
                    text: 'backoffice.nav.System',
                },
                {
                    text: 'backoffice.nav.Saml',
                    active: true,
                }
            ],
            permission: 'SamlConfigGetList',
        },
    },
    {
        name: E_ROUTE_SYSTEM.SYSTEM_SQL,
        path: '/system/system-sql',
        component: () => import(/* webpackChunkName: "system" */ '../../views/system/SystemSql/SystemSql.vue'),
        props: true,
        meta: {
            keepAlive: false,
            breadcrumb: [
                {
                    text: 'backoffice.nav.DeveloperTool',
                },
                {
                    text: 'backoffice.nav.System',
                },
                {
                    text: 'backoffice.nav.Sql',
                    active: true,
                }
            ],
            permission: 'SqlGetList',
        },
    },
    ...(ENABLE_REGION_SWITCH
        ? [{
                name: E_ROUTE_SYSTEM.REGION_SWITCH,
                path: '/system/region-switch',
                component: () => import(/* webpackChunkName: "system" */ '../../views/system/RegionSwitch/RegionSwitch.vue'),
                meta: {
                    keepAlive: false,
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.DeveloperTool',
                        },
                        {
                            text: 'backoffice.nav.System',
                        },
                        {
                            text: 'backoffice.nav.RegionSwitch',
                            active: true,
                        }
                    ],
                    permission: 'SystemManager',
                },
            }]
        : [])
];
/** 搜索引擎页面级子菜单 */
export const systemSearchEngineManagementRoutePermissionTable = [
    { name: `${E_ROUTE_SEARCHENGINE_MANAGEMENT.COMPANY}`, permission: 'CompanyIndexGetList' },
    { name: `${E_ROUTE_SEARCHENGINE_MANAGEMENT.ACCOUNT}`, permission: 'AccountIndexGetList' },
    { name: `${E_ROUTE_SEARCHENGINE_MANAGEMENT.HISTORY}`, permission: 'HistoryIndexGetList' }
];
